<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :height="tableHeight - 44"
      :loading="loading"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <b-button
            size="sm"
            variant="outline-success"
            @click="editVisitDetail('add')"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l('form_add_btn') || '新增' }}
          </b-button>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="viewMyVisit('view', row.visitCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-show="row.modifyFlag === 'Y'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="editMyVisit(row, 'edit', row.visitCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="row.modifyFlag === 'Y'"
          >
            <i class="el-icon-delete tool-btn" @click="del(row.visitCode)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
    <pagination
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      size="small"
      align="right"
      slot="pager"
      @change="handlePaginationChange"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
// import { mapState } from 'vuex'
export default {
  mixins: [TableAutoHeight],

  components: {},
  computed: {
    // ...mapState('admin/user', ['info']),
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    scmCode: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      loading: false,
      disabled: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('table_scm_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 110,
          fixed: 'left',
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'visitDate',
          headerAlign: 'center',
          align: 'center',
          width: 120,
          title: this.$l('table_visit_label_visitDate') || '拜访日期',
          showHeaderOverflow: 'title',
        },
        {
          field: 'visitOwnerName',
          headerAlign: 'center',
          align: 'center',
          width: 150,
          title: this.$l('table_visit_label_visitOwnerName') || '拜访负责人',
          showHeaderOverflow: 'title',
        },
        {
          field: 'visitPerson',
          headerAlign: 'center',
          align: 'left',
          minWidth: 170,
          title: this.$l('table_visit_label_visitPerson') || '拜访团队成员',
          showHeaderOverflow: 'title',
        },
        {
          field: 'scmPerson',
          headerAlign: 'center',
          align: 'left',
          minWidth: 170,
          title: this.$l('visit_label_scmPerson') || '厂商人员',
          showHeaderOverflow: 'title',
        },
        {
          field: 'visitTitle',
          headerAlign: 'center',
          align: 'left',
          minWidth: 350,
          title: this.$l('visit_label_visitTitle') || '拜访目的',
          showHeaderOverflow: 'title',
        },
        // {
        //   field: 'visitDescription',
        //   headerAlign: 'center',
        //   align: 'left',
        //   minWidth: 400,
        //   title: this.$l('visit_label_visitDescription') || '拜访情况说明',
        //   showHeaderOverflow: 'title'
        // },
        {
          field: 'modifyTime',
          align: 'center',
          width: 170,
          title: this.$l('table_scm_label_modifyInfo') || '最新更新',
          showHeaderOverflow: 'title',
        },
      ],
      tableData: [],
      params: {
        scmCode: '',
      },
      page: {
        curPage: 1,
        pageSize: 20,
        pageTotal: 0,
      },
      total: 0,
    }
  },
  watch: {
    scmCode: {
      handler(scmCode) {
        if (scmCode !== '') {
          this.init(scmCode)
        }
      },
      immediate: true,
    },
  },
  methods: {
    init(scmCode) {
      this.params.scmCode = scmCode
      // this.params.userCode = this.info.userCode
      this.getData()
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.getData()
      })
    },
    getData() {
      // 加载表格数据
      this.$api
        .scmInfoVisitListApi({
          ...this.page,
          ...this.params,
        })
        .then((res) => {
          this.page.pageTotal = res.body.count

          this.tableData = res.body.data
        })
    },
    viewMyVisit(type, val) {
      this.$router.push({
        name: 'personal-myScmInfo-myVisit-view',
        params: {
          pageType: type,
          visitCode: val,
        },
      })
    },
    editVisitDetail(type) {
      this.$router.push({
        name: 'personal-myScmInfo-myVisit-edit',
        params: {
          pageType: type,
          visitCode: 'add',
          scmCode: this.scmCode,
        },
      })
    },
    editMyVisit(row, type, val) {
      this.$router.push({
        name: 'personal-myScmInfo-myVisit-edit',
        params: {
          pageType: type,
          visitCode: val,
        },
      })
    },
    del(val) {
      let msg = this.$l('INDEX.tips_delete') || '是否要删除该记录？?'
      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.$api
          .scmInfoVisitDelApi({
            visitCode: val,
          })
          .then(() => {
            this.$message.success(
              this.$l('INDEX.tips_delete_ok') || '删除成功！'
            )
            this.getData()
          })
      })
    },
  },
}
</script>
